import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  getCompanyLogo,
} from "../../../utils/utils.common";
import { sweetAlert } from "../../../utils/swal";
import { downloadBase64File } from "../../../utils/pdf-downloader";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { FleetService } from "../fleet-service/fleet.service";
import { AssigTripsService } from "../../assigned-trips/assigntrips-service/assigntrips-service";
@Component({
  selector: "app-fleet-list",
  templateUrl: "./fleet-list.component.html",
  styleUrls: ["./fleet-list.component.css"],
})
export class FleetListComponent implements OnInit, OnDestroy {
  path = null;
  fleetList = [];
  search: any;
  status = "active";
  fundingSources: any=[];
  preFundingSources = {};

  constructor(
    private fleetService: FleetService,
    private assignTripService: AssigTripsService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getCorporateUserList();
  }

  getFleetList() {
    this.fleetService
      .getCredentialedFleetList({'isFleetSection': true,'status': this.status})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.fleetList = data;
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getCorporateUserList() {
    this.assignTripService
      .getCorporateUserList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.fundingSources = data;
          this.preFundingSources = this.fundingSources.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        this.getFleetList();
      });
  }

  onChangeStatus() {
    this. getFleetList()
  }

  getCompanyImage(driverCar) {
    return getCompanyLogo(driverCar);
  }

  downloadSingleFleetQR(fleetId) {
    this.fleetService.getSingleFleetQR(fleetId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          downloadBase64File(data.content, data.pdfName);
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );
  }

  downloadAllFleetQR() {
    const data = {
      status: this.path,
    };
    this.fleetService.getAllFleetQR(data)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          downloadBase64File(data.content, data.pdfName);
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );
  }

  ngOnDestroy(): void {
  }
}
